import PT from 'prop-types';

const TeamShape = PT.shape({
  id: PT.number.isRequired,
  division: PT.string.isRequired,
  name: PT.string.isRequired,
  city: PT.string.isRequired,
  abbr: PT.string.isRequired,
  color: PT.string,
  conference: PT.string.isRequired,
  logo: PT.shape({
    small: PT.string.isRequired,
    large: PT.string.isRequired,
    medium: PT.string.isRequired,
    tiny: PT.string.isRequired,
    extra_large: PT.string.isRequired,
  }),
});

const TeamsType = PT.objectOf(PT.objectOf(PT.arrayOf(TeamShape)));

export default TeamsType;



// WEBPACK FOOTER //
// ./src/lib/proptypes/teams.js